import { render, staticRenderFns } from "./SirenSearchBar.vue?vue&type=template&id=3c4439ee&scoped=true&"
import script from "./SirenSearchBar.vue?vue&type=script&lang=js&"
export * from "./SirenSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SirenSearchBar.vue?vue&type=style&index=0&id=3c4439ee&prod&lang=scss&scoped=true&"
import style1 from "./SirenSearchBar.vue?vue&type=style&index=1&id=3c4439ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4439ee",
  null
  
)

export default component.exports